module.exports = __webpack_public_path__ + "nextchem.png?2ba2b21f253f8c58c076ef8c2579b6a0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nextchem.png
// module id = 240
// module chunks = 0